import { points, pointsPlusPay, find, shield } from 'roo-ui/assets';

export const pointsImage = {
  src: points,
  alt: 'use points image',
};

export const pointsPlusPayImage = {
  src: pointsPlusPay,
  alt: 'use points plus pay image',
};

export const findImage = {
  src: find,
  alt: 'find image',
};

export const shieldImage = {
  src: shield,
  alt: 'shield image',
};
